
import { SearchAvtalByAnvandareResponseDTO } from "~app/common/models/virkeskop/v2/SearchAvtalByAnvandareResponseDTO";

export class MoveAvtal {
    avtal: SearchAvtalByAnvandareResponseDTO;
    selected: boolean;

    constructor(avtal: SearchAvtalByAnvandareResponseDTO, selected: boolean) {
        this.selected = selected;
        this.avtal = avtal;
    }
}
